import React from 'react';
import { RouteProp, useRoute } from '@react-navigation/native';
import { CRMParamList } from '../../../typings/Params';
import { RootNavigation } from '../../../Routes';
import TicketDetailComponent from './TicketDetailComponent';

export default function KanbanTicketDetail({ navigation }: {
    navigation: RootNavigation;
}) {
    const route = useRoute<RouteProp<CRMParamList, 'KanbanTicketDetail'>>();
    return <TicketDetailComponent navigation={navigation} route={route} page={'kanban-ticket-detail'} />;
}
